import React from 'react'
import { mount } from './mount.js'
import { Login } from './views/Login.js'

const urlParams = new URLSearchParams(window.location.search)
const redirect = urlParams.get('redirect')

mount(<Login redirect={redirect || ''} />)
